// İSG uzmanı portalı — Panel KPI karosu (S34-4, design review `S34-carbon-phase2-plan.md` §4
// "KPI tile (Carbon clickable tile)"). Emsal: eski panonun figür şeridi (`DashboardPage.tsx`'in
// S33 sürümü) — tipografi ORADAN taşındı, yalnız kart biçimine (Carbon "clickable tile") geçti.
//
// **Tek `<a>` (M10).** Kart bir bağlantıysa TÜMÜ tek `<Link>` — okuma sırası "etiket, sayı,
// bağlam" (ekran okuyucu doğal DOM sırasını izler, ok `aria-hidden`). `href` verilmezse (eşleşen
// bir liste YOKSA, M10 normatif) kart bir `<div>` olarak render edilir — ok da GÖRÜNMEZ (bir
// bağlantı VAADİ vermez).
//
// **`value: null` render EDİLMEZ — çağıran taraf tile'ı hiç MONTE ETMEZ** (E1 alan kapısı; "yetki
// yok" `0` DEĞİL, YOKLUK'tur — dosya başı disiplini, `dashboard.ts`). Bu bileşen `value: number`
// alır (asla `null`), null kararını `DashboardPage.tsx`'in filtre adımı verir.
//
// **Yükleniyor** — TEK bir `GET /dashboard/summary` isteğinin PAYLAŞILAN durumu (altı karo ayrı
// sorgu DEĞİL); `isLoading` iken sayı `Skeleton` (48×32), etiket/bağlam yine görünür (iskelet
// "hangi karo" sorusunu YANIT vermeye devam eder).
//
// **S34-45 design review S1 — bağlam satırı SABİT yükseklik.** Bağlamı OLAN karolar sayıyı bir
// satır YUKARI iterken bağlamı OLMAYANLAR itmiyordu; 1280'de aynı satırdaki iki karo farklı y'de
// oturuyordu. Bağlam yoksa boş `aria-hidden` bir `<p>` AYNI yüksekliği tutar — tüm sayılar AYNI
// temel çizgide. owner review B4-7: yükseklik `h-4` (1 satır) → `h-8` (2 satır) — bkz. alttaki not.
//
// **M7 → owner review B4-7 — kırpılan bağlam metni artık 2 satıra SARAR, KESİLMEZ.** `truncate`
// (tek satır) HER genişlikte kırpıyordu — 1584px'lik sayfa tavanında karo genişliği ~254px'te
// SABİT, metin sütunu ~206px, "Firma geneli · 0 taşeronun belgesi 30 gün içinde dolacak" (56
// karakter) hiçbir genişlikte tek satıra sığmaz (owner review S35-design.md "QA note (a)").
// `line-clamp-2` — 2 satırdan uzunu YİNE elipsle keser (`title` hâlâ tam metni taşır, hover/
// dokunmatik uzun-basma için), ama artık İKİ satır pay verir. Asıl düzeltme kopyanın KISALTILMASI
// (aşağıya bkz., `dashboard.kpi.contractorDocsExpiring.context`) — bu yalnız TAŞMAYI ele alır.
//
// **Kompakt boyut (owner review B2 item 3, 2026-09-28).** 6 karo 1366×768'de (nav genişletilmiş)
// 2 satıra düşünce (`DashboardPage.tsx`'in ızgara notu) eski `min-h-[128px]`+`p-4`+`text-[28px]`
// ekranın İLK GÖRÜNÜMÜNÜN çoğunu kaplıyor, "Aksiyon gerekli" listesi kaydırmadan hiç
// görünmüyordu. Sayı `text-[28px]/leading-8` → `text-2xl/leading-7` (24px, HÂLÂ en büyük
// rakam Panelde — sadece "smaller" HEDEFİ kadar), dolgu `p-4` → `p-3`, dış-iç boşluk `gap-2` →
// `gap-1.5`, taban yükseklik `min-h-[128px]` → `min-h-[100px]` (label 2 satıra sarsa bile HÂLÂ
// sığar). Karo başına ~30-35px kazanç × 2 satır = "Aksiyon gerekli"nin katlanmadan ÖNCE
// başlaması için gereken payın çoğu (kalanı `DashboardPage.tsx`'in ızgara eşiği değişikliğinden
// gelir). owner review B4-7 — bağlam satırının `h-4`→`h-8` büyümesi bu bütçeyi EN KÖTÜ durumda
// (hem etiket HEM bağlam 2 satıra sarıp) yalnız TEK karoda (`contractorDocsExpiring`, tek DE
// senaryosu) ~+16px büyütür; owner review S35-design.md'nin kendi hesabı (Seçenek B) bunun
// 768px'te katlanma noktasını ~342px'ten ~358px'e taşıdığını, HÂLÂ rahatça sığdığını doğruluyor.
//
// **QA B5 (`S35-qa.md` "B4 re-check" #6) — S35-design.md'nin öngördüğü risk gerçekleşti.**
// 1366×768'de kenar çubuğu GENİŞLETİLMİŞ iken (6 karo, ~140px etiket genişliği) DE
// `dashboard.kpi.expiringPermits` 3 satır istiyordu, bu satırın `line-clamp-2`'si "Tagen
// ablaufen"i kırpıyordu. Kırpma sınırı (bu dosya) SABİT kaldı — düzeltme yalnız `locales.ts`'te
// kısa bir DE etiket (headless Chrome + gerçek IBM Plex Sans ile ölçülüp 2 satıra indirildi);
// diğer 5 karo × tr/en/de aynı genişlikte zaten 2 satırda sığıyordu (ölçüldü, değişmedi).

import { Skeleton, cn } from '@isgportal/shared';
import { ArrowRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export interface KpiTileProps {
  label: string;
  /** `Intl.NumberFormat(culture)` ile biçimlenmiş HAZIR metin — bu bileşen locale bilmez. */
  formattedValue: string;
  /** İkinci satır — yalnız gerçekten backed bir veriden (dosya başlığı, "context lines" kuralı). */
  context?: ReactNode;
  /** Eşleşen bir liste VARSA (M10) — verilmezse kart bağlantısız `<div>` olarak render edilir. */
  href?: string;
  isLoading?: boolean;
}

export function KpiTile({ label, formattedValue, context, href, isLoading }: KpiTileProps) {
  const body = (
    <>
      <p className="line-clamp-2 text-sm text-muted" title={label}>
        {label}
      </p>
      <div className="flex items-end justify-between gap-2">
        <div className="min-w-0">
          {isLoading ? (
            <Skeleton className="mt-1 h-7 w-12" />
          ) : (
            <p className="tnum text-2xl font-semibold leading-7 text-fg">{formattedValue}</p>
          )}
          {context ? (
            <p
              className="mt-1 h-8 line-clamp-2 text-xs text-muted"
              title={typeof context === 'string' ? context : undefined}
            >
              {context}
            </p>
          ) : (
            <p aria-hidden="true" className="mt-1 h-8" />
          )}
        </div>
        {href ? <ArrowRight className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" /> : null}
      </div>
    </>
  );

  const className = cn(
    'flex min-h-[100px] flex-col justify-between gap-1.5 bg-surface p-3 transition-colors',
    href
      ? 'hover:bg-surface-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring'
      : null,
  );

  if (!href) {
    return <div className={className}>{body}</div>;
  }
  return (
    <Link to={href} className={className}>
      {body}
    </Link>
  );
}
